// Helper to make use case "when clicked outside close this modal" easier
export const onClickOutside = (el, callback) => {

    document.addEventListener('click', function(event) {
      const isClickInside = el.contains(event.target);

      if (!isClickInside) {
          callback();
      }
    });

}
